export default defineNuxtPlugin(() => {
  // Handle route changes for SPA OneTrust banner reloading
  const router = useRouter();

  router.afterEach((to, from) => {
    // Only reload banner if user has selected language and it's a different route
    if (to.path !== from.path && localStorage.getItem('preferredIso') && window.reloadOTBanner) {
      // Small delay to ensure page is ready
      setTimeout(() => {
        window.reloadOTBanner();
      }, 100);
    }
  });
});
